import './styles.scss';

import { Button } from '@mui/material';

import { RangeEnum } from '../../../model/range.enum';

const DATE_OPTIONS: { [key: string]: string } = {
  [RangeEnum.D1]: '1 day',
  [RangeEnum.D5]: '5 days',
  [RangeEnum.W1]: '1 week',
  [RangeEnum.M1]: '1 month',
  [RangeEnum.M6]: '6 months',
  [RangeEnum.Y1]: '1 year',
  [RangeEnum.CUSTOM]: 'All time',
};

interface CalendarProps {
  setSelectedDate: (value: RangeEnum | undefined) => void;
  selectedDate: RangeEnum | undefined;
}

export function CalendarInteractiveSelectPeriod({ selectedDate, setSelectedDate }: CalendarProps) {
  const renderDateOptions = () => {
    const handleSelectedDate = (key: RangeEnum | undefined) => {
      setSelectedDate(key);
    };

    return Object.keys(DATE_OPTIONS).map((itemKey: string, index: number) => {
      const isSelected = itemKey === selectedDate;
      return (
        <Button
          type="button"
          className={`date-option-button ${isSelected ? 'is-selected' : ''}`}
          onClick={() => handleSelectedDate(isSelected ? undefined : (itemKey as RangeEnum))}
          key={index}
          tabIndex={index}
        >
          {DATE_OPTIONS[itemKey]}
        </Button>
      );
    });
  };

  return (
    <div className="calendar-interactive-select-period-container">
      <div className="date-options">{renderDateOptions()}</div>
    </div>
  );
}
